import { makeStyles } from '@material-ui/core/styles'

import { inboxCardShape } from './cardShapes'

export default makeStyles((theme) => ({
  actionRow: {
    gap: theme.spacing(1)
  },
  inboxCard: inboxCardShape(theme)
}))
